import TableCell from "@mui/material/TableCell"
import Tooltip from "@mui/material/Tooltip"
import PropTypes from "prop-types"

import { trimLongString } from "../../../common/utils"
import { adminTableBodyCellSx } from "./AdminHeaderTableCell"

const DEFAULT_CHAR_LIMIT = 20

export default function AdminTruncatedCell({
  value,
  limit = DEFAULT_CHAR_LIMIT,
  align,
  emptyDisplay = "—",
  ...cellProps
}) {
  const text = value == null || value === "" ? emptyDisplay : String(value)
  const truncated = trimLongString(text, limit)
  const isTruncated = text !== emptyDisplay && text.length > limit

  const cell = (
    <TableCell
      align={align}
      {...cellProps}
      sx={{
        maxWidth: { xs: 140, sm: 180, md: 220, lg: 260 },
        minWidth: { xs: 56, sm: 72 },
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: "text.secondary",
        ...adminTableBodyCellSx,
        ...cellProps.sx,
      }}
    >
      {truncated}
    </TableCell>
  )

  if (isTruncated) {
    return (
      <Tooltip title={text} arrow placement="top-start">
        {cell}
      </Tooltip>
    )
  }

  return cell
}

AdminTruncatedCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  limit: PropTypes.number,
  align: PropTypes.string,
  emptyDisplay: PropTypes.string,
}
